import React from 'react';
import {
  createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import SlugLink from '../../../slug-link';
import { BlogArticleFragment } from '../../../../__generated__/gatsby-types';
import colors from '../../../../themes/main-colors';
import { useTranslation } from '../../../../hooks/useTranslation';
import { useIsMobile } from '../../../../util/style-utils';

const usePreviousNextStyles = makeStyles(() =>
    createStyles({
      root: (props: {isMobile: boolean}) => ({
        display: 'flex', 
        justifyContent: 'space-between', 
        marginTop: '30px', 
        padding: '50px 30px', 
        backgroundColor: colors.linenWhite,
        border: props.isMobile ? `solid ${colors.lightGray1}` : undefined,
        borderWidth: props.isMobile ? '1px 0' : undefined,
      }),
      linkContainer: (props: {isMobile: boolean}) => ({
        width: props.isMobile ? 170 : 325, 
        '& p': {
          marginBottom: '5px',
        },
      }),
      previous: {
        textAlign: 'left',
        '& span': {
          paddingRight: '10px',
        },
      },
      next: {
        textAlign: 'right',
        '& span': {
          paddingLeft: '10px',
        },
      },
      spacer: {
        flexGrow: 1, 
        minWidth: 30,
      }
    }),
  );
  
type Props = {
    previous?: BlogArticleFragment,
    next?: BlogArticleFragment,
}

export const PreviousNext = (props: Props) => {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const classes = usePreviousNextStyles({isMobile});
    const { previous, next } = props;

    if(previous|| next) {
        return (
        <div className={classes.root}>
            {previous && ( 
            <div className={`${classes.linkContainer} ${classes.previous}`}>
                <Typography variant='body2'>
                <span>&lt;</span>{t('PREVIOUS_ARTICLE')}
                </Typography>
                <SlugLink
                slug={previous.slug}
                linkText={previous.title}
                />
            </div>    
            )}
            <div className={classes.spacer}></div>
            {next && ( 
            <div className={`${classes.linkContainer} ${classes.next}`}>
                <Typography variant='body2'>
                {t('NEXT_ARTICLE')}<span>&gt;</span>
                </Typography>
                <SlugLink
                slug={next.slug}
                linkText={next.title}
                />
            </div>     
            )}
        </div>
        )
    }
    return null;
}
export default PreviousNext;
